import { ref } from 'vue';
import { useEventListener } from '@/composables/useEventListener';

export const useIsOnline = () => {
  const isOnline = ref(navigator.onLine);

  function updateStatus() {
    isOnline.value = navigator.onLine;
  }

  useEventListener(window, 'online', updateStatus);
  useEventListener(window, 'offline', updateStatus);

  return {
    isOnline,
  };
};
